import { jsonProperty, Serializable } from "ts-serializable";
import Resposta from "./Resposta";

class AvaliacaoResposta extends Serializable{


    @jsonProperty(String, null)
    id: string | null = null;

    @jsonProperty(String, null)
    dataInclusao: string | null = null;

    @jsonProperty(Boolean, null)
    finalizada: boolean | null = false;

    @jsonProperty([Resposta], null)
    respostas: Resposta | null = null;

}  

export default AvaliacaoResposta;